import { ToolkitItem } from '@/lib/sanity/queries/get-toolkit-item';
import { CSS } from '@/stitches.config';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React from 'react';
import { Box } from './box';

type ToolkitItemProps = {
  toolkitItem: ToolkitItem;
  css?: CSS;
  children: React.ReactNode;
  onActivate?: () => void;
  onDeactivate?: () => void;
};

export function ToolkitItemLink({
  toolkitItem,
  children,
  css,
  onActivate,
  onDeactivate,
}: ToolkitItemProps) {
  const router = useRouter();

  let toolkitItemSlug = `/toolkit/${toolkitItem.slug.current}`;
  if (router.pathname === '/project/[...slug]') {
    toolkitItemSlug = `/project/${router.query.slug?.[0]}${toolkitItemSlug}`;
  } else if (router.query.slug?.includes('services')) {
    toolkitItemSlug = `/services${toolkitItemSlug}`;
  }

  return (
    <Link
      href={{
        pathname: toolkitItemSlug,
      }}
      scroll={false}
      shallow={false}
      passHref
    >
      <Box
        as="a"
        css={css}
        onPointerEnter={onActivate}
        onFocus={onActivate}
        onPointerLeave={onDeactivate}
        onBlur={onDeactivate}
      >
        {children}
      </Box>
    </Link>
  );
}
